import type { Formula } from '@viome/viome-base/src/usecase/Nutrition/Nutrition.model';

export const FILTER = {
  RANK: 'rank',
  TYPE: 'type',
  PRODUCT: 'product',
  BOOKMARKED: 'bookmarked',
} as const;

export interface MyIngredientsPageQueryParams {
  rank: number;
  type: string;
  product: string;
  bookmarked: boolean;
}

export interface GroupedSupplement {
  productId: number;
  productName: string;
  formulas: Record<string, Formula>;
}
